jQuery(function () {

    let fs = null;
    if ( (fs = window.localStorage.getItem('font-size')) !== null ) {
        jQuery('html').css('font-size', fs + 'px');
    }
    if ( window.localStorage.getItem('contrast') === 'true' ) {
        jQuery('body').addClass('high_contrast');
    }

    jQuery('#increaseFontSize').on('click', function ( evt ) {
        let fs = jQuery('html').css('font-size');
        fs = Math.min((parseInt(fs) + 4), 30);
        jQuery('html').css('font-size', fs + 'px');
        window.localStorage.setItem('font-size', fs);
    });

    jQuery('#decreaseFontSize').on('click', function () {
        let fs = jQuery('html').css('font-size');
        fs = Math.max((parseInt(fs) - 4), 10);
        jQuery('html').css('font-size', fs + 'px');
        window.localStorage.setItem('font-size', fs);
    });

    jQuery('#toggleContrast').on('click', function () {
        jQuery('body').toggleClass('high_contrast');
        window.localStorage.setItem('contrast', jQuery('body').hasClass('high_contrast'));
    });


    jQuery('.hamburger').on( 'click', () => {
        jQuery('body').toggleClass('nav-open');
        jQuery('.sidebar.sidebar--left').toggleClass('is-open');
    });

    jQuery('.menu-toggle').on('click tap', openMenu);
    jQuery('.menu-toggle').on('keypress', function ( evt ) {
        if ( evt.key === ' ' ) {
            evt.preventDefault();
            jQuery(this).trigger('click');
        }
    });

    function openMenu() {
        jQuery(this).toggleClass('is-open');
        jQuery(this).next('.menu').toggleClass('is-open');
    }

});

jQuery(window).on("load", function ( e ) {

});

jQuery(window).on("resize", function ( e ) {

});